var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('body',[_c('iframe',{staticStyle:{"overflow":"hidden","height":"100%","width":"100%"},attrs:{"src":"https://versions.etherego.com/","frameborder":"0","height":"100%","width":"100%"}}),_vm._v("--> ")])
}]

export { render, staticRenderFns }